import { Link } from 'react-router-dom';

interface ComicCardProps {
  id: number;
  title: string;
  author: string;
  cover: string;
  rating: number;
  status: string;
  latestChapter: string;
  category?: string;
  tags?: string[];
}

export default function ComicCard({ id, title, author, cover, rating, status, latestChapter, tags }: ComicCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group block bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300"
      data-product-shop
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={cover}
          alt={`${title} 漫画封面`}
          title={`${title} - 八仔漫画网`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 left-2">
          <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${
            status === '连载中' ? 'bg-primary-500 text-white' : 'bg-accent-500 text-white'
          }`}>
            {status}
          </span>
        </div>
        <div className="absolute top-2 right-2 bg-background-950/70 text-white text-xs px-1.5 py-0.5 rounded flex items-center gap-1">
          <i className="ri-star-fill text-yellow-400 text-xs"></i>
          {rating}
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-bold text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors">
          {title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1">{author}</p>
        {tags && tags.length > 0 && (
          <div className="flex flex-wrap gap-1 mt-2">
            {tags.slice(0, 3).map((tag) => (
              <span key={tag} className="px-1.5 py-0.5 rounded text-xs bg-secondary-100 text-secondary-700 whitespace-nowrap">
                {tag}
              </span>
            ))}
          </div>
        )}
        <p className="text-xs text-foreground-500 mt-2 line-clamp-1">{latestChapter}</p>
      </div>
    </Link>
  );
}